<template>
  <v-container grid-list-xs fluid>
    <form-dialog v-model="dialog" :title="formTitle" @input="reset">
      <v-sheet class="py-2 px-4">
        <v-text-field
          :label="$t('name')"
          data-vv-name="name"
          v-validate="'required'"
          :data-vv-as="$t('name')"
          v-model="program_area.name"
          :error-messages="errors.collect('name')"
        />
        <div class="my-2 di-flex justify-end">
          <v-btn color="btn_color secondary" :loading="loading" @click="save">
            {{ $t("save") }}
          </v-btn>
        </div>
      </v-sheet>
    </form-dialog>

    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3">
      <v-flex
        xs12
        class="di-flex justify-space-between align-center grey lighten-4"
      >
        <strong class="title_label pl-2" slot="activator">
          <span>{{ title }}</span>
        </strong>
        <v-btn
          icon
          small
          class="shadow"
          color="primary"
          @click="dialog = true"
          v-if="can('edit_settings')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 class="di-flex justify-space-between align-center mt-3">
        <v-text-field
          small
          outline
          single-line
          hide-details
          class="rounded"
          v-model="search"
          style="max-width:320px"
          :placeholder="$t('search')"
          prepend-inner-icon="mdi-magnify"
        />
        <v-spacer />
        <v-btn
          icon
          flat
          class="ma-0 pa-0"
          color="grey darken-2"
          @click="printTable(false)"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          icon
          flat
          class="ma-0 pa-0"
          color="grey darken-2"
          @click="printTable(true)"
        >
          <v-icon>file_download</v-icon>
        </v-btn>
      </v-flex>

      <v-flex xs12>
        <v-data-table
          ref="tbl"
          item-key="id"
          :items="items"
          :search="search"
          :headers="headers"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.index + 1 }}</td>
            <td>{{ $t(props.item.type) }}</td>
            <td>{{ props.item.name }}</td>
            <td>
              <v-btn
                icon
                flat
                small
                class="ma-0 pa-0"
                color="grey darken-2"
                v-if="can('edit_settings')"
                @click="editItem(props.item)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                icon
                flat
                small
                class="ma-0 pa-0"
                color="grey darken-2"
                v-if="can('edit_settings')"
                @click="deleteItem(props.item)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "programAreas",
  props: { value: Object },
  data() {
    return {
      items: [],
      title: "",
      search: null,
      dialog: false,
      loading: false,
      editedIndex: -1,
      program_area: {}
    };
  },
  computed: {
    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "100px" },
      { text: vm.$t("type"), value: "type", width: "200px" },
      { text: vm.$t("name"), value: "name" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ],
    type: vm => vm.$route.params.type,
    formTitle: vm =>
      vm.editedIndex > -1
        ? `Edit ${vm.program_area.type}`
        : `New ${vm.program_area.type}`
  },

  methods: {
    deleteItem(item) {
      let vm = this;
      this.$alert(`/program-areas/${item.id}`).then(() => {
        vm.items.splice(vm.items.indexOf(item), 1);
      });
    },

    editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.program_area = Object.assign({}, item);
      this.dialog = true;
    },

    reset() {
      this.dialog = false;
      this.loading = false;
      this.editedIndex = -1;
      this.$validator.reset();
      let type = this.$route.params.type;
      this.title =
        type == "province" ? this.$t("operational_areas") : this.$t("programs");
      this.program_area = { id: null, name: null, type };
    },

    save() {
      this.loading = true;
      this.$validator.validateAll().then(succeed => {
        if (succeed) {
          this.axios
            .post("program-areas", this.program_area)
            .then(res => {
              if (this.editedIndex > -1)
                Object.assign(this.items[this.editedIndex], res.data.data);
              else this.items.push(res.data.data);
              this.reset();
            })
            .catch(() => (this.loading = false));
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true
          });
        }
      });
    },

    printTable(excel) {
      let data = {
        title: `Lists of ${this.title}`,
        items: this.items,
        headers: this.headers.slice(1, this.headers.length - 1)
      };

      if (excel) return this.xl_tables(data, "CSOs");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },

    initData() {
      this.reset();
      let type = this.$route.params.type;
      this.axios.get(`program-areas?type=${type}`).then(res => {
        this.items = res.data.data;
      });
    }
  },
  watch: {
    $route() {
      this.initData();
    }
  },
  created() {
    this.initData();
  }
};
</script>
